<template>
  <ul class="note">
    <li @click="addnote(1920, true)" :class="{disabled: !allowedInput}"><img src="../../../assets/btn/2on.png" width="30" height="60" /></li>
    <li @click="addnote(960, true)" :class="{disabled: !allowedInput}"><img src="../../../assets/btn/4on.png" width="30" height="60" /></li>
    <li @click="addnote(480, true)" :class="{disabled: !allowedInput}"><img src="../../../assets/btn/8on.png" width="30" height="60" /></li>
    <li @click="addnote(240, true)" :class="{disabled: !allowedInput}"><img src="../../../assets/btn/16on.png" width="30" height="60" /></li>
  </ul>
</template>

<script>
export default {
  name: 'triplet_note',
  computed: {
    lastNoteEnds: function(){
      return this.$store.getters.lastNoteEnds;
    },
    beats: function(){
      return this.$store.state.beats;
    },
    allowedInput: function (){
      return (960*this.beats - this.lastNoteEnds) % 240 === 0
    },
  },
  methods: {
    addnote: function (length, bool) {
      if (this.allowedInput) {
        this.$emit('setnote', {'length': length, 'bool': bool});
      }
    }
  }
}
</script>

<style scoped>
.disabled{
  opacity: 0.5;
  background-color: #ddd;
}
</style>